/* eslint-disable import/no-cycle */
import {
  EO_UPDATE_ROW_FILTER_MAPPING,
  EO_UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED,
  UPDATE_ROW_FILTER_MAPPING,
  UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED,
} from '../../../components/ViewControls/RowsFilter/constant';
import { httpService } from '../../../http-service/httpService';
import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  GROUP_BY_APP_VALUE,
} from '../../../utils/constant';
import { setCommonError } from '../global/action';
import {
  ACTIVE_ADVANCED_FILTERS,
  CERT_DETAILS_FILTER_CHANGE_TRIGGER,
  CERT_DETAILS_LISTS_LOADING,
  CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
  CLEAR_ALL_FILTERS,
  CLEAR_SMART_FILTERS,
  FETCH_SMART_FILTERS_META_FAILURE,
  FETCH_SMART_FILTERS_META_SUCCESS,
  RESET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_APPLIED_ROW_FILTERS,
  SET_APPLIED_SAVI_ACTION_KEYS,
  SET_CERT_FILTERS,
  SET_CERTS_ACTIONS_FILTER,
  SET_CLEAR_FILTERS_BTN_STATUS,
  SET_CLEAR_HIERARCHY_BTN_STATUS,
  SET_CLEAR_SEARCH_BTN_STATUS,
  SET_COLS_FILTERS,
  SET_DYNAMIC_SORT_FILTER_DETAILS,
  SET_GROUP_BY_OPTIONS,
  SET_IS_SMART_FILTER_APPLIED,
  SET_ROWS_FILTERS,
  SET_SMART_FILTER_ID,
} from '../types';
import { URL_CONTROLS_FILTER_API, URL_SMART_CARD_API } from '../urls';

export const triggerFilterChange = () => (dispatch) => {
  dispatch({ type: CERT_DETAILS_FILTER_CHANGE_TRIGGER });
};

export const setCreateFilterActionMap = (actionMap) => (dispatch) => {
  dispatch({
    type: SET_CERTS_ACTIONS_FILTER,
    payload: actionMap,
  });
};

export const setGroupByOptions = (groupByOptions) => (dispatch) => {
  dispatch({
    type: SET_GROUP_BY_OPTIONS,
    payload: { results: groupByOptions },
  });
};

export const setRowsFiltersForCerts = (rowsFilters) => (dispatch) => {
  dispatch({
    type: SET_ROWS_FILTERS,
    payload: { results: rowsFilters },
  });
};

export const setColsFiltersForCerts = (colsFilters) => (dispatch) => {
  dispatch({
    type: SET_COLS_FILTERS,
    payload: { results: colsFilters },
  });
};

export const setActiveAdvancedFilters = (filters) => (dispatch) => {
  dispatch({
    type: ACTIVE_ADVANCED_FILTERS,
    payload: { results: filters },
  });
};

export const setTriggerClearBtnForFilters = (status) => (dispatch) => {
  dispatch({
    type: SET_CLEAR_FILTERS_BTN_STATUS,
    payload: status,
  });
};

export const setTriggerClearBtnForSearch = (status) => (dispatch) => {
  dispatch({
    type: SET_CLEAR_SEARCH_BTN_STATUS,
    payload: status,
  });
};

export const setTriggerClearBtnForHierarchy = (status) => (dispatch) => {
  dispatch({
    type: SET_CLEAR_HIERARCHY_BTN_STATUS,
    payload: status,
  });
};

export const setCertTriggerFromSearchOrFilter = (trigger) => (dispatch) => {
  dispatch({
    type: CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
    payload: trigger,
  });
};

export const setSelectedRowFilters = (appliedRowFilters) => (dispatch) => {
  dispatch({
    type: SET_APPLIED_ROW_FILTERS,
    payload: appliedRowFilters,
  });
};

export const setDefaultRowFilters = () => (dispatch, getState) => {
  const {
    core: { campaignType },
    global: { viewRowsList },
  } = getState().certifications.details;

  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  const mapping = isEOCampaign
    ? EO_UPDATE_ROW_FILTER_MAPPING
    : UPDATE_ROW_FILTER_MAPPING;
  const objectsMapping = isEOCampaign
    ? EO_UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED
    : UPDATE_ROW_FILTER_MAPPING_WITH_OBJECTS_TO_BE_INCLUDED;

  const defaultRowFilters = Object.entries(mapping)
    .filter(([, label]) => viewRowsList?.includes(objectsMapping[label]))
    .map(([key]) => key);

  dispatch(setSelectedRowFilters(defaultRowFilters));
  dispatch({ type: SET_ROWS_FILTERS, payload: { results: defaultRowFilters } });
};

export const setAppliedSaviActionKeys = (keys) => (dispatch) => {
  dispatch({
    type: SET_APPLIED_SAVI_ACTION_KEYS,
    payload: keys,
  });
};

export const setIsSmartApplied = (status) => (dispatch) => {
  dispatch({
    type: SET_IS_SMART_FILTER_APPLIED,
    payload: status,
  });
};

export const setSmartFilterId = (smartFilterId) => (dispatch) => {
  dispatch({
    type: SET_SMART_FILTER_ID,
    payload: smartFilterId,
  });
};

export const getCertsFilterData = (certKey) => async (dispatch, getState) => {
  const {
    core: { columnNames },
    viewControls: { groupByOptions },
  } = getState().certifications.details;

  const selectedGroupByValue = groupByOptions?.find(
    (option) => option.isChecked
  )?.value;

  const body = {
    certkey: certKey,
    filterColumns: columnNames,
  };

  if (selectedGroupByValue === GROUP_BY_APP_VALUE) {
    body.group_by = selectedGroupByValue;
  }

  try {
    const { data } = await httpService.post(URL_CONTROLS_FILTER_API, body);

    const { valueCountMap, messageKeys } = data;

    const modifiedFilters = {};

    Object.keys(valueCountMap).forEach((filter) => {
      modifiedFilters[filter] = {};
    });

    dispatch(setCommonError({ isError: false, error: null }));

    dispatch({
      type: SET_CERT_FILTERS,
      payload: { results: { valueCountMap, messageKeys } },
    });
  } catch (error) {
    dispatch({
      type: SET_CERT_FILTERS,
      payload: { results: null },
    });
    dispatch(
      setCommonError({ isError: true, error: 'Failed to fetch filter data' })
    );
  }
};

// CR-21413: updateCertsFilter - commented out, filter state is now sent
// in the request body via triggerFilterChange(). Keeping for future reference.
// export const updateCertsFilter =
//   (
//     filterKey,
//     filterValue,
//     isChecked,
//     clearAllCustomSessionAttributes = false
//   ) =>
//   async (dispatch, getState) => {
//     const {
//       core: { isLoading },
//       global: { certKey },
//     } = getState().certifications.details;
//
//     const body = {
//       fieldname: filterKey,
//       value: filterValue,
//       checked: isChecked ? '1' : '0',
//       certkey: certKey,
//     };
//
//     if (clearAllCustomSessionAttributes) {
//       body.clearAllCustomSessionAttributes = 'true';
//     }
//
//     dispatch({
//       type: CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
//       payload: true,
//     });
//
//     if (!isLoading) {
//       dispatch(setCertsDetailListLoading(true));
//     }
//
//     dispatch(setCommonError({ isError: false, error: null }));
//
//     try {
//       const response = await httpService.post(URL_UPDATE_FILTER_API, body, axiosTimeoutConfig);
//       if (response.status === 200) {
//         return true;
//       }
//       throw Error('No 200 response from server');
//     } catch (error) {
//       dispatch(setCommonError({ isError: true, error: 'Failed to update filter' }));
//     }
//
//     return true;
//   };

// CR-21413: clearCertsFilter - commented out, filter clearing is now handled
// via triggerFilterChange(). Keeping for future reference.
// export const clearCertsFilter = () => async (dispatch, getState) => {
//   const {
//     core: { isLoading },
//     global: { certKey },
//   } = getState().certifications.details;
//
//   const body = { certkey: certKey, clearFilter: 'true' };
//
//   dispatch({
//     type: CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
//     payload: true,
//   });
//
//   if (!isLoading) {
//     dispatch(setCertsDetailListLoading(true));
//   }
//
//   dispatch(setCommonError({ isError: false, error: null }));
//
//   try {
//     const { status } = await httpService.post(URL_UPDATE_FILTER_API, body, axiosTimeoutConfig);
//     if (status === 200) {
//       return true;
//     }
//     throw Error('No 200 response from server');
//   } catch (error) {
//     dispatch(setCertsDetailListLoading(false));
//     dispatch(setCommonError({ isError: true, error: 'Failed to clear filter' }));
//   }
//
//   return true;
// };

const fetchFactorsFromTrustData = (factor) => {
  const factorsList = [];

  Object.entries(factor).forEach(([key, value]) => {
    const { messageKey, messageKeyDescription, payload } = value;
    const factorItem = {
      id: key,
      title: messageKey,
      description: messageKeyDescription,
      iconKind: payload.icon,
      payload,
    };

    factorsList.push(factorItem);
  });

  return factorsList;
};

export const fetchSmartFiltersMeta = (certkey) => async (dispatch) => {
  try {
    const { data } = await httpService.post(URL_SMART_CARD_API, { certkey });
    const { riskFactorsSmartCards, trustFactorsSmartCards } = data;

    // Commented the trust factors due to requirement change. Trust factors will be re-introduced as a separate tab later.
    const sanitizedData = {
      risk_factors: {
        title: riskFactorsSmartCards.messageKey,
        description: riskFactorsSmartCards.messageKeyDescription,
        iconKind: 'SmartFilterRiskMeter',
        factors: fetchFactorsFromTrustData(riskFactorsSmartCards.smartCards),
      },
      // trust_factors: {
      //   title: trustFactorsSmartCards.messageKey,
      //   description: trustFactorsSmartCards.messageKeyDescription,
      //   iconKind: 'SmartFilterTrustMeter',
      //   factors: fetchFactorsFromTrustData(
      //     trustFactorsSmartCards.trustSmartCards
      //   ),
      // },
    };

    const trustFactors = fetchFactorsFromTrustData(
      trustFactorsSmartCards.trustSmartCards
    );

    sanitizedData.risk_factors.factors.push(...trustFactors);

    const idToMove = 'CONFIDENCE';
    const index = sanitizedData?.risk_factors?.factors?.findIndex(
      (factor) => factor.id === idToMove
    );

    if (index > -1) {
      const [element] = sanitizedData.risk_factors.factors.splice(index, 1);

      sanitizedData.risk_factors.factors.unshift(element);
    }

    dispatch({
      type: FETCH_SMART_FILTERS_META_SUCCESS,
      payload: sanitizedData,
    });
  } catch (err) {
    dispatch({ type: FETCH_SMART_FILTERS_META_FAILURE });
  }
};

export const updateCertSmartFilter =
  (payload, postDispatchAction) => async (dispatch) => {
    try {
      const { dontRefreshItems, smartFilterIdToSet } = postDispatchAction;

      const isApplying = !payload.clearFilter;

      dispatch({ type: SET_IS_SMART_FILTER_APPLIED, payload: isApplying });
      dispatch({
        type: SET_SMART_FILTER_ID,
        payload: isApplying ? smartFilterIdToSet || '' : '',
      });

      dispatch({ type: CERT_DETAILS_LISTS_LOADING, payload: true });
      dispatch({
        type: CERT_DETAILS_TRIGGER_FROM_SEARCH_OR_FILTER,
        payload: true,
      });

      if (!dontRefreshItems) {
        dispatch(triggerFilterChange());
      }
    } catch (error) {
      dispatch(
        setCommonError({ isError: true, error: 'Failed to update filter' })
      );
    }
  };

export const clearSmartFiltersAction = (flag) => (dispatch) =>
  dispatch({
    type: CLEAR_SMART_FILTERS,
    payload: flag,
  });

export const clearAllFiltersAction = (flag) => (dispatch) =>
  dispatch({
    type: CLEAR_ALL_FILTERS,
    payload: flag,
  });

export const setDynamicSortDetails =
  (columnName, sortDirection) => async (dispatch) => {
    dispatch({
      type: SET_DYNAMIC_SORT_FILTER_DETAILS,
      payload: { columnName, sortDirection },
    });
  };

export const resetDynamicSortDetails = () => async (dispatch) => {
  dispatch({ type: RESET_DYNAMIC_SORT_FILTER_DETAILS });
};
